const WasteTypesOptionsArray = [
    "pg",
    "pc",
    "gl",
    "oc",
    "tx",
    "ol",
    "rg",
    "rt",
    "bs",
    "pr",
    "ml",
    "ot"
]
export default WasteTypesOptionsArray;